import React, {useState} from "react";
import {Button, Input, useMantineTheme} from "@mantine/core";
import AceEditor from "react-ace";
import "ace-builds/src-min-noconflict/ext-language_tools";
import "ace-builds/src-min-noconflict/mode-mysql";
import "ace-builds/src-noconflict/theme-monokai";
import {SqlEditorProp} from "../../../../../../types/types";
import "./sqlEditor.css";
import {popNotification} from "../../../notification/notificationUtils";
import {X} from "tabler-icons-react";
import {themeProvider} from "../../../../../style/utils";
import {SqlQueryConfigurationValidator} from "../sqlQueryConfigurationValidator";

const validator = new SqlQueryConfigurationValidator();

const SqlEditor = (props: SqlEditorProp) => {


    const batchQueryComments = `
# You have selected the execution mode as Batch Query.
# In the batch mode a list of login ids will provided as 'loginIds' so please add that specific filter in your query.
# You can add this filter as part of the 'IN' clause like ':loginIds'
# example select findKpi() as value from ck_user where loginId in (:loginIds)
      `

    const splitQueryComment = `
# You have selected the execution mode as Split Query.
# In the Split mode the query will run against each user. So please add the loginId filter in your query.
# You can add this filter as part of the where condition like ':loginId'
# example select findKpi() as value from ck_user where loginId = :loginId;
       `

    const executionMode = props.props.kpiInfo.executionMode;
    const comments = executionMode === 'BATCH' ? batchQueryComments : splitQueryComment;

    const query = comments + "\n" + (props.query ? props.query : "")


    const [queryName, setQueryName] = useState<string>(props.name ?? "");
    const [sqlQuery, setSqlQuery] = useState<string>(query);

    const currentTheme = useMantineTheme();

    function prepareQuery(sql: string) {
        return sql.split("\n")
            .map(line => line.trim())
            .filter(line => !line.startsWith("#"))
            .filter(line => !line.startsWith("--"))
            .join("\n")
            .trim();
    }

    function checkValidation(): boolean {
        const finalQuery = prepareQuery(sqlQuery);
        if (queryName === "") {
            popNotification("Alert", "Please enter query Name", "red", <X/>);
            return false;
        }
        if (!finalQuery || finalQuery === '') {
            popNotification("Alert", "Please provide the query", "red", <X/>);
            return false;
        }
        const error = validator.validateQuery(executionMode, finalQuery);
        if (error) {
            popNotification("Alert", error.message, "red", <X/>);
            return false;
        }
        return true;
    }

    function setQuery(): void {
        const finalQuery = prepareQuery(sqlQuery);
        console.log(finalQuery)
        if (props.edit) {
            props.props && props.props.kpiInfo.configuration.queries.forEach((query: any) => {
                if (query.name === props.name) {
                    query.name = queryName;
                    query.query = finalQuery;
                }
            });
        } else {
            props.props && props.props.kpiInfo.configuration.queries.push({
                name: queryName,
                query: finalQuery,
            });
        }
    }

    function submitQuery() {
        let flag = checkValidation();
        console.log("flag", flag)
        if (flag) {
            setQuery();
            props.forceUpdate();
            props && props.closeModal();
            props.setSqlQuery("");
        }
    }

    const onChangeQuery = (event: any) => {
        setSqlQuery(event);
    };

    const addQueryName = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setQueryName(event.target.value);
    };
    const openRunSqlDisplay = ()=>{
        props.setSqlQuery(prepareQuery(sqlQuery));
        props.setSqlEditorOpened(false);
        props.setSqlRunnerOpened(true);
    }

    return (
        <div>
            <div className="sqlEditor-heading"> Query Editor </div>
            <div className="sqlEditor-container">
                <Input
                    className="sqlEditor-input"
                    placeholder="QueryName"
                    onChange={addQueryName}
                    value={queryName}
                />
                <AceEditor
                    className="sqlEditor-editor"
                    aria-label="editor"
                    mode="mysql"
                    theme={
                        currentTheme.colorScheme === "light" ? "github" : "solarized_dark"
                    }
                    wrapEnabled={true}
                    name="editor"
                    fontSize={16}
                    minLines={15}
                    maxLines={15}
                    width="100%"
                    height="100%"
                    showPrintMargin={false}
                    placeholder="write you query here..."
                    editorProps={{$blockScrolling: true}}
                    setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        enableSnippets: true,
                    }}
                    value={sqlQuery}
                    onChange={onChangeQuery}
                />
            </div>
            <div className="sqlEditor-button-container">
                <div className="sqlEditor-button">
                    <Button sx={themeProvider} color="teal" variant="outline"
                            onClick={submitQuery}>
                        Submit
                    </Button>
                </div>
                <div className="sqlEditor-button">
                    <Button sx={themeProvider} color="teal" variant="outline" 
                            onClick={openRunSqlDisplay}>
                        Test Query
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SqlEditor;
